var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  slice = [].slice;

window.NavigationView = (function(superClass) {
  extend(NavigationView, superClass);

  function NavigationView() {
    return NavigationView.__super__.constructor.apply(this, arguments);
  }

  NavigationView.prototype.events = {
    "click .navigation-desktop .dropdown > a": "toggleMenu",
    "click .navigation-mobile .dropdown > a": "toggleMenu",
    "click .mobile-nav-item.navigate > a": "toggleMobileNav",
    "click .mobile-nav-item.browse > a": "toggleMobileSearch",
    "click .mobile-nav-item > a": "toggleMobileNavItemsFadeStatus"
  };

  NavigationView.prototype.initialize = function() {
    this.body = $(document.body);
    return this.desktopNav = this.$("[data-desktop-nav]");
  };

  NavigationView.prototype.toggleMenu = function(e) {
    var a, dropdown, megaDropdown, megaMenuHeight;
    e.preventDefault();
    a = this.$(e.target);
    dropdown = a.parent(".dropdown");
    megaDropdown = a.parent(".nav-item-meganav");
    this.$megaMenu = this.$(".navigation-desktop-mega");
    megaMenuHeight = this.$megaMenu.outerHeight() - 1;
    dropdown.toggleClass("active");
    dropdown.siblings(".dropdown").removeClass("active");
    dropdown.find(".dropdown-nav .dropdown").removeClass("active");
    if (megaDropdown.hasClass("active")) {
      this.$megaMenu.toggleClass("active").css("height", megaMenuHeight);
    } else {
      this.$megaMenu.removeClass("active").css("height", "");
    }
    $(window).resize((function(_this) {
      return function() {
        if (document.documentElement.offsetWidth < 768 && megaDropdown.hasClass("active")) {
          _this.$megaMenu.removeClass("active");
          return dropdown.toggleClass("active");
        }
      };
    })(this)).trigger("resize");
    return this.adjustSimpleNavPosition();
  };

  NavigationView.prototype.adjustSimpleNavPosition = function() {
    var i, item, itemOffset, len, navWidth, ref, results;
    navWidth = this.desktopNav.width();
    ref = this.$(".navigation-desktop > .dropdown");
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      item = ref[i];
      this.$item = $(item);
      if (!this.$item.hasClass("nav-item-meganav")) {
        itemOffset = this.$item.offset();
        if (this.$item.find(".second-tier").length && itemOffset.left + 154 > navWidth) {
          this.$item.find(".second-tier").addClass("adjust-right");
        }
        if (this.$item.find(".third-tier").length && itemOffset.left + 300 > navWidth) {
          results.push(this.$item.find(".third-tier").addClass("adjust-right"));
        } else {
          results.push(void 0);
        }
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  NavigationView.prototype.toggleMobileNav = function(e) {
    this.$(".navigation-mobile-list").toggleClass("active");
    return this.$(".mobile-browse-container").removeClass("active");
  };

  NavigationView.prototype.toggleMobileSearch = function(e) {
    this.$(".mobile-browse-container").toggleClass("active");
    return this.$(".navigation-mobile-list").removeClass("active");
  };

  NavigationView.prototype.toggleMobileNavItemsFadeStatus = function(e) {
    var navItems, target;
    navItems = this.$(".mobile-nav-item");
    target = $(e.target).closest(navItems);
    if (target.hasClass("active")) {
      navItems.removeClass("fade");
      return target.removeClass("active");
    } else {
      navItems.not(target).addClass("fade");
      return target.addClass("active").removeClass("fade");
    }
  };

  return NavigationView;

})(Backbone.View);

window.HeaderView = (function(superClass) {
  extend(HeaderView, superClass);

  function HeaderView() {
    return HeaderView.__super__.constructor.apply(this, arguments);
  }

  HeaderView.prototype.events = {
    "click .search-toggle-button": "toggleSearch",
    "change .shop-by-category, .shop-by-vendor": "fireSearchSelect"
  };

  HeaderView.prototype.initialize = function() {
    this.navigation = new NavigationView({
      el: this.$el
    });
    return $(document.body).on("click", (function(_this) {
      return function(e) {
        if (!_this.$(e.target).closest(".search-toggle-button").length) {
          return _this.$(".search-toggle-button").removeClass("open");
        }
      };
    })(this));
  };

  HeaderView.prototype.toggleSearch = function(e) {
    if (this.$(".search-toggle-button").hasClass("open") && this.$(e.target).hasClass("search-browse-parent-outline")) {
      return this.$(".search-toggle-button").removeClass("open");
    } else {
      this.$(".search-browse-container").css({
        top: $(".search-browse-parent-outline").height()
      });
      return this.$(".search-toggle-button").addClass("open");
    }
  };

  HeaderView.prototype.fireSearchSelect = function(e) {
    var target;
    target = this.$(e.target);
    if (target.val().length) {
      return window.location = target.val();
    }
  };

  HeaderView.prototype.prepareRemove = function() {
    return this.navigation.remove();
  };

  return HeaderView;

})(Backbone.View);

window.SlideshowView = (function(superClass) {
  extend(SlideshowView, superClass);

  function SlideshowView() {
    return SlideshowView.__super__.constructor.apply(this, arguments);
  }

  SlideshowView.prototype.initialize = function() {
    this.flickity = null;
    return this._validate();
  };

  SlideshowView.prototype.update = function($el) {
    this.$el = $el;
    if (this.flickity == null) {
      return this._validate();
    }
  };

  SlideshowView.prototype.remove = function() {
    this.$slideshow.flickity('destroy');
  };

  SlideshowView.prototype.onBlockSelect = function(event) {
    var $block, $slideIndex;
    $block = $(event.target);
    $slideIndex = $block.data('slide-index');
    if (this.$slideshow) {
      this.$slideshow.flickity('select', $slideIndex, false, false);
      this.$slideshow.flickity('pausePlayer');
      return this._updateHeight();
    }
  };

  SlideshowView.prototype.onBlockDeselect = function(event) {
    return this.$slideshow.flickity('unpausePlayer');
  };

  SlideshowView.prototype._validate = function() {
    var autoplay, slideCount;
    this.$slideshow = this.$el;
    slideCount = this.$slideshow.data('slideshow-slides');
    autoplay = this.$slideshow.data('autoplay');
    return this._setupSlideshow(slideCount, autoplay);
  };

  SlideshowView.prototype._updateHeight = function() {
    return this.$slideshow.imagesLoaded((function(_this) {
      return function() {
        return _this.$viewPort.height(_this.$slide.eq(_this.flickity.selectedIndex).height());
      };
    })(this));
  };

  SlideshowView.prototype._setupSlideshow = function(slideCount, autoplay) {
    var slideshowNavigation;
    slideshowNavigation = true;
    if (slideCount === 1) {
      slideshowNavigation = false;
    }
    this.$slideshow.flickity({
      imagesLoaded: true,
      autoPlay: autoplay,
      pageDots: false,
      prevNextButtons: slideshowNavigation,
      contain: true,
      cellSelector: ".slide",
      wrapAround: true
    });
    this.flickity = this.$slideshow.data('flickity');
    this.$viewPort = this.$slideshow.find('.flickity-viewport');
    this.$slide = this.$slideshow.find('.slide');
    this.$slideshow.imagesLoaded((function(_this) {
      return function() {
        return _this.$viewPort.height(_this.$slide.eq(0).height());
      };
    })(this));
    return this.$slideshow.on("cellSelect", (function(_this) {
      return function() {
        return _this._updateHeight();
      };
    })(this));
  };

  return SlideshowView;

})(Backbone.View);

window.ProductListView = (function(superClass) {
  extend(ProductListView, superClass);

  function ProductListView() {
    return ProductListView.__super__.constructor.apply(this, arguments);
  }

  ProductListView.prototype.events = {
    "preload-images": "preloadImages"
  };

  ProductListView.prototype.initialize = function() {
    return this.preloadImages();
  };

  ProductListView.prototype.preloadImages = function(e, imageWrap) {
    var i, len, ref, results;
    ref = this.$(".product-item-image");
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      imageWrap = ref[i];
      results.push(this.showImage(imageWrap));
    }
    return results;
  };

  ProductListView.prototype.showImage = function(imageWrap) {
    var image;
    imageWrap = $(imageWrap);
    image = imageWrap.find("img");
    return imageWrap.imagesLoaded((function(_this) {
      return function() {
        if (image.height() < 100) {
          return imageWrap.find(".product-details-overlay").addClass("landscape");
        }
      };
    })(this));
  };

  return ProductListView;

})(Backbone.View);

window.PromotionBlocksView = (function(superClass) {
  extend(PromotionBlocksView, superClass);

  function PromotionBlocksView() {
    return PromotionBlocksView.__super__.constructor.apply(this, arguments);
  }

  PromotionBlocksView.prototype.initialize = function() {
    return this.initializedClass = 'promotion-blocks-initialized';
  };

  PromotionBlocksView.prototype.update = function($el) {
    this.$el = $el;
    return this.transitionend = (function(transition) {
      var transEndEventNames;
      transEndEventNames = {
        "-webkit-transition": "webkitTransitionEnd",
        "-moz-transition": "transitionend",
        "-o-transition": "oTransitionEnd",
        transition: "transitionend"
      };
      return transEndEventNames[transition];
    })(Modernizr.prefixed("transition"));
  };

  return PromotionBlocksView;

})(Backbone.View);

window.TwitterView = (function(superClass) {
  extend(TwitterView, superClass);

  function TwitterView() {
    return TwitterView.__super__.constructor.apply(this, arguments);
  }

  TwitterView.prototype.initialize = function() {
    this.initializedClass = 'twitter-initialized';
    return this._validate();
  };

  TwitterView.prototype._validate = function() {
    var isInitialized, showRetweets, username;
    this.$tweetContainer = this.$("[data-twitter-tweets]", this.$el);
    username = $("[data-twitter-username]", this.$el).attr("data-twitter-username");
    showRetweets = $("[data-twitter-show-retweets]", this.$el).length;
    isInitialized = this.$el.hasClass(this.initializedClass);
    return this._fetchTweets(username, showRetweets, isInitialized);
  };

  TwitterView.prototype._fetchTweets = function(username, showRetweets, isInitialized) {
    var config;
    if (!username.length) {
      return this._hasError(false);
    }
    if (isInitialized) {
      return;
    }
    config = {
      "profile": {
        "screenName": username
      },
      "maxTweets": 3,
      "enableLinks": true,
      "showUser": true,
      "showTime": true,
      "showRetweet": showRetweets,
      "customCallback": (function(_this) {
        return function(tweets) {
          return _this._renderTweets(tweets);
        };
      })(this),
      "showInteraction": false
    };
    return twitterFetcher.fetch(config);
  };

  TwitterView.prototype._renderTweets = function(tweets) {
    var i, len, results, tweet, tweetWrapper;
    tweetWrapper = $("[data-tweet]");
    if (tweets.length) {
      results = [];
      for (i = 0, len = tweets.length; i < len; i++) {
        tweet = tweets[i];
        tweetWrapper.append("<div class='twitter-tweet'>" + tweet + "</div>");
        tweetWrapper.find(".user").remove();
        results.push(tweetWrapper.find(".timePosted").addClass("accent-text").appendTo());
      }
      return results;
    } else {
      this.$tweetContainer.remove();
      return console.log("No tweets to display. Most probable cause is an incorrectly entered username.");
    }
  };

  TwitterView.prototype._hasError = function(response) {
    this.$el.toggleClass(this.initializedClass, false);
    this.$tweetContainer.html();
    if (response) {
      return console.log("Twitter error: " + response.meta.error_message);
    }
  };

  TwitterView.prototype.update = function() {
    return this._validate();
  };

  return TwitterView;

})(Backbone.View);

window.InstagramView = (function(superClass) {
  extend(InstagramView, superClass);

  function InstagramView() {
    return InstagramView.__super__.constructor.apply(this, arguments);
  }

  InstagramView.prototype.initialize = function() {
    this.initializedClass = 'instagram-initialized';
    return this._validate();
  };

  InstagramView.prototype._validate = function() {
    var accessToken, isInitialized, photoCount;
    this.$photoContainer = this.$("[data-instagram-photos]", this.$el);
    this.accessTokenError = this.$el.find('[data-instagram-error]').attr('data-instagram-error');
    accessToken = $("[data-instagram-token]", this.$el).attr("data-instagram-token");
    photoCount = $("[data-instagram-photo-count]", this.$el).attr("data-instagram-photo-count");
    isInitialized = this.$el.hasClass(this.initializedClass);
    return this._getPhotos(accessToken, photoCount, isInitialized);
  };

  InstagramView.prototype._getPhotos = function(accessToken, photoCount, isInitialized) {
    var url;
    if (!accessToken.length) {
      return this._hasError(false);
    }
    if (isInitialized) {
      return;
    }
    url = "https://api.instagram.com/v1/users/self/media/recent?access_token=" + accessToken + "&count=" + photoCount + "&callback=";
    return $.ajax({
      type: "GET",
      dataType: "jsonp",
      url: url,
      success: (function(_this) {
        return function(response) {
          var i, len, photo, ref, results;
          if (response.meta.code === 200) {
            ref = response.data;
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              photo = ref[i];
              results.push(_this.$photoContainer.append("<a class='instagram-photo' target='_blank' href='" + photo.link + "'><img src='" + photo.images.low_resolution.url + "'/></a>"));
            }
            return results;
          } else {
            return _this._hasError(response);
          }
        };
      })(this),
      error: (function(_this) {
        return function(response) {
          return _this._hasError(response);
        };
      })(this)
    });
  };

  InstagramView.prototype._hasError = function(response) {
    this.$el.removeClass(this.initializedClass);
    this.$photoContainer.append("<div class=\"instagram-error\" data-instagram-error>" + this.accessTokenError + "</div>");
    this.$errorContainer = this.$photoContainer.find('[data-instagram-errror]');
    if (response) {
      return console.log("Instagram error: " + response.meta.error_message);
    }
  };

  InstagramView.prototype.update = function() {
    return this._validate();
  };

  return InstagramView;

})(Backbone.View);

window.SocialWidgetsView = (function(superClass) {
  extend(SocialWidgetsView, superClass);

  function SocialWidgetsView() {
    return SocialWidgetsView.__super__.constructor.apply(this, arguments);
  }

  SocialWidgetsView.prototype.initialize = function() {
    if ($('[data-instagram]', this.$el).length) {
      this.instagram = new InstagramView({
        el: this.$el
      });
    }
    if ($('[data-twitter]', this.$el).length) {
      return this.twitter = new TwitterView({
        el: this.$el
      });
    }
  };

  SocialWidgetsView.prototype.update = function($el) {
    if (this.instagram != null) {
      this.instagram.setElement($el);
      this.instagram.update();
    }
    if (this.twitter != null) {
      this.twitter.setElement($el);
      return this.twitter.update();
    }
  };

  SocialWidgetsView.prototype.remove = function() {
    var ref, ref1;
    if ((ref = this.instagram) != null) {
      ref.remove();
    }
    return (ref1 = this.twitter) != null ? ref1.remove() : void 0;
  };

  return SocialWidgetsView;

})(Backbone.View);

window.HomeView = (function(superClass) {
  extend(HomeView, superClass);

  function HomeView() {
    return HomeView.__super__.constructor.apply(this, arguments);
  }

  HomeView.prototype.initialize = function() {
    return this.sectionBinding();
  };

  HomeView.prototype.sectionBinding = function() {
    this.sections = new ThemeEditor();
    this.sections.register('home-slideshow', this.slideshow(this.sections));
    this.sections.register('featured-products', this.featuredProduct(this.sections));
    this.sections.register('promotion-blocks', this.promotionBlocks(this.sections));
    return this.sections.register('home-social-widgets', this.socialWidgets(this.sections));
  };

  HomeView.prototype.slideshow = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new SlideshowView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        return this.onSectionSelect(event);
      },
      onBlockSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.onBlockSelect(event) : void 0;
      },
      onBlockDeselect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.onBlockDeselect(event) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  HomeView.prototype.featuredProduct = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new ProductListView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.setElement(instance.$container) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  HomeView.prototype.promotionBlocks = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new PromotionBlocksView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionSelect: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        return (ref = this.instances[instance.sectionId]) != null ? ref.update(instance.$container) : void 0;
      },
      onSectionDeselect: function(event) {
        var instance;
        instance = sections.getInstance(event);
        return this.onSectionSelect(instance);
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  HomeView.prototype.socialWidgets = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new SocialWidgetsView({
          el: instance.$container
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (this.instances[instance.sectionId] == null) {
          return this.init(instance);
        }
      },
      onSectionDeselect: function(event) {
        var instance, ref, ref1;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.setElement(instance.$container);
        }
        return (ref1 = this.instances[instance.sectionId]) != null ? ref1.update(instance.$container) : void 0;
      },
      onSectionUnload: function(event) {
        var instance, ref;
        instance = sections.getInstance(event);
        if ((ref = this.instances[instance.sectionId]) != null) {
          ref.remove();
        }
        return delete this.instances[instance.sectionId];
      }
    };
  };

  return HomeView;

})(Backbone.View);

window.CollectionView = (function(superClass) {
  extend(CollectionView, superClass);

  function CollectionView() {
    return CollectionView.__super__.constructor.apply(this, arguments);
  }

  CollectionView.prototype.events = {
    "click .click-to-load-button": "loadNewProducts",
    "change .collection-sort-filter select": "updateSortFilter",
    "change .collection-tag-filter select": "updateTagFilter"
  };

  CollectionView.prototype.initialize = function() {
    this.productListView = null;
    this.productList = [];
    this.sectionBinding();
    return this.render();
  };

  CollectionView.prototype.render = function() {
    this.productListView = new ProductListView({
      el: this.$(".collection-content")
    });
    this.productList = this.$(".product-list");
    if (this.$('.collection-tag-filter').length) {
      new SelectView({
        el: this.$('.collection-tag-filter select')
      });
    }
    if (this.$('.collection-sort-filter').length) {
      new SelectView({
        el: this.$('.collection-sort-filter select')
      });
    }
    if (this.$("#content").hasClass("has-pagination") && (this.$("#content").hasClass("click-to-load") || this.$("#content").hasClass("infinite-scroll"))) {
      return this.initializeInfiniteScroll();
    }
  };

  CollectionView.prototype.remove = function() {
    return this.productList.infinitescroll('destroy');
  };

  CollectionView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        _this.remove();
        _this.productList = [];
        _this.productListView.remove();
        return _this.undelegateEvents();
      };
    })(this));
  };

  CollectionView.prototype.initializeInfiniteScroll = function() {
    var behavior;
    this.clickToLoad = this.$(".click-to-load-button");
    this.section = JSON.parse($('[data-section-json]', this.$el).text());
    this.paginateMethod = this.section.products_pagination_method;
    this.currentProductsCount = this.$(".product-item").length;
    if (this.paginateMethod === "click-to-load") {
      behavior = "twitter";
    } else {
      behavior = "";
    }
    return this.productList.infinitescroll({
      behavior: behavior,
      navSelector: "#pagination",
      nextSelector: "#pag-next a",
      itemSelector: ".product-item",
      loading: {
        finished: void 0,
        finishedMsg: "",
        img: "",
        msg: null,
        msgText: "",
        selector: null,
        speed: "fast",
        start: void 0,
        bufferPx: 200
      }
    }, (function(_this) {
      return function(newProducts) {
        return _this.onProductsLoad(newProducts);
      };
    })(this));
  };

  CollectionView.prototype.onProductsLoad = function(newProducts) {
    this.productList.trigger("preload-images", [newProducts]);
    if (Theme.currencySwitcher) {
      $(".currency-switcher select").trigger("reset-currency");
    }
    this.currentProductsCount = this.currentProductsCount + $(newProducts).length;
    if (this.currentProductsCount === parseInt(this.productList.data("product-count"))) {
      this.clickToLoad.hide();
      return this.$(".collection-content").addClass("no-pagination");
    }
  };

  CollectionView.prototype.loadNewProducts = function(e) {
    return this.productList.infinitescroll("retrieve");
  };

  CollectionView.prototype.updateSortFilter = function(e) {
    var Sorting, currentSearch, i, index, len, part, search, searchParts;
    Sorting = {};
    Sorting.sort_by = this.$(".collection-sort-filter select").val();
    if ($(e.target).closest(".collection-sorting").hasClass("vendor-collection")) {
      currentSearch = location.search;
      searchParts = currentSearch.split("&");
      for (index = i = 0, len = searchParts.length; i < len; index = ++i) {
        part = searchParts[index];
        if (part.indexOf("sort_by") !== -1) {
          searchParts.splice(index, 1);
        }
      }
      search = searchParts.join("&");
      return location.search = search + "&" + (jQuery.param(Sorting));
    } else {
      return location.search = jQuery.param(Sorting);
    }
  };

  CollectionView.prototype.updateTagFilter = function(e) {
    var collection, currentQuery, tag;
    collection = $(e.target).data("collection");
    tag = $(e.target).val();
    currentQuery = location.search;
    if (tag === "all") {
      return window.location.href = "/collections/" + collection + currentQuery;
    } else {
      return window.location.href = "/collections/" + collection + "/" + tag + currentQuery;
    }
  };

  return CollectionView;

})(Backbone.View);

window.ImageZoomView = (function(superClass) {
  extend(ImageZoomView, superClass);

  function ImageZoomView() {
    return ImageZoomView.__super__.constructor.apply(this, arguments);
  }

  ImageZoomView.prototype.events = {
    "prepare-zoom": "prepareZoom",
    "click": "toggleZoom",
    "mouseout .product-zoom": "toggleZoom",
    "mousemove .product-zoom": "zoomImage"
  };

  ImageZoomView.prototype.initialize = function() {
    this.zoomArea = this.$(".product-zoom");
    this.$newImage = null;
    return this.$el.imagesLoaded((function(_this) {
      return function() {
        return _this.prepareZoom();
      };
    })(this));
  };

  ImageZoomView.prototype.prepareZoom = function() {
    var newImage, photoAreaHeight, photoAreaWidth;
    photoAreaWidth = this.$el.width();
    photoAreaHeight = this.$el.height();
    newImage = new Image();
    this.$newImage = $(newImage);
    this.$newImage.on("load", (function(_this) {
      return function() {
        var ratio, ratios;
        _this.zoomImageWidth = newImage.width;
        _this.zoomImageHeight = newImage.height;
        ratios = new Array();
        ratios[0] = _this.zoomImageWidth / photoAreaWidth;
        ratios[1] = _this.zoomImageHeight / photoAreaHeight;
        ratio = Math.max.apply(Math, ratios);
        if (ratio < 1.4) {
          _this.$el.removeClass("zoom-enabled");
        } else {
          _this.$el.addClass("zoom-enabled");
          return _this.zoomArea.css({
            backgroundImage: "url(" + newImage.src + ")"
          });
        }
      };
    })(this));
    return newImage.src = this.$("img").attr("src");
  };

  ImageZoomView.prototype.toggleZoom = function(e) {
    if (this.$el.hasClass("zoom-enabled")) {
      if (e.type === "mouseout") {
        this.zoomArea.removeClass("active");
        return;
      }
      if (this.zoomArea.hasClass("active")) {
        this.zoomArea.removeClass("active");
      } else {
        this.zoomArea.addClass("active");
      }
      return this.zoomImage(e);
    }
  };

  ImageZoomView.prototype.zoomImage = function(e) {
    var bigImageOffset, bigImageX, bigImageY, mousePositionX, mousePositionY, newBackgroundPosition, ratioX, ratioY, zoomHeight, zoomWidth;
    zoomWidth = this.zoomArea.width();
    zoomHeight = this.zoomArea.height();
    bigImageOffset = this.$el.offset();
    bigImageX = Math.round(bigImageOffset.left);
    bigImageY = Math.round(bigImageOffset.top);
    mousePositionX = e.pageX - bigImageX;
    mousePositionY = e.pageY - bigImageY;
    if (mousePositionX < zoomWidth && mousePositionY < zoomHeight && mousePositionX > 0 && mousePositionY > 0) {
      if (this.zoomArea.hasClass("active")) {
        ratioX = Math.round(mousePositionX / zoomWidth * this.zoomImageWidth - zoomWidth / 2) * -1;
        ratioY = Math.round(mousePositionY / zoomHeight * this.zoomImageHeight - zoomHeight / 2) * -1;
        if (ratioX > 0) {
          ratioX = 0;
        }
        if (ratioY > 0) {
          ratioY = 0;
        }
        if (ratioX < -(this.zoomImageWidth - zoomWidth)) {
          ratioX = -(this.zoomImageWidth - zoomWidth);
        }
        if (ratioY < -(this.zoomImageHeight - zoomHeight)) {
          ratioY = -(this.zoomImageHeight - zoomHeight);
        }
        newBackgroundPosition = ratioX + "px " + ratioY + "px";
        return this.zoomArea.css({
          backgroundPosition: newBackgroundPosition
        });
      }
    }
  };

  ImageZoomView.prototype.prepareRemove = function() {
    return this.$newImage.off('load');
  };

  return ImageZoomView;

})(Backbone.View);

window.ProductView = (function(superClass) {
  extend(ProductView, superClass);

  function ProductView() {
    return ProductView.__super__.constructor.apply(this, arguments);
  }

  ProductView.prototype.events = {
    "click #product-image-thumbnails img": "switchProductImage",
    "click #product-add input": "addToCart"
  };

  ProductView.prototype.initialize = function() {
    this.sectionBinding();
    return this._render();
  };

  ProductView.prototype._render = function() {
    var $productJSON, $productSettings, i, len, ref, select;
    this.settings = window.settingsJSON;
    this.product = window.productJSON;
    this.section = JSON.parse($('[data-section-json]', this.$el).text());
    this.zoomEnabled = this.section.enable_zoom;
    this.relatedEnabled = this.section.related_products;
    this.variants = this.product.variants;
    this.images = this.product.images;
    this.minimumPriceArea = this.$(".product-price-minimum");
    this.addingToCart = false;
    this.productArea = this.$(".product-page", this.$el);
    this.$productForm = $(".product-form", this.productArea);
    this.formID = parseInt(this.$productForm.attr("data-product-form"), 10);
    this.productSelect = "#product-select-" + this.formID;
    this.$priceArea = $(".product-form .product-price", this.productArea);
    this.$addToCartButton = $("#product-add input", this.productArea);
    this.$productThumbnails = $("#product-image-viewer #product-image-thumbnails img", this.productArea);
    this.hasAjax = this.productArea.is("[data-ajax]");
    $productJSON = $("[data-product-json-" + this.formID + "]", this.productArea);
    $productSettings = $("[data-product-settings-" + this.formID + "]", this.productArea);
    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    this.$variantDropdowns = $("[data-option-select=" + this.formID + "]", this.productArea);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    if (this.$(".product-form").length) {
      this.setupVariants();
    }
    this.addingToCart = false;
    if (this.relatedEnabled) {
      this.relatedView = new ProductListView({
        el: this.$("#related-products")
      });
    }
    if (this.zoomEnabled) {
      this.zoomView = new ImageZoomView({
        el: this.$(".product-main-image")
      });
    }
    ref = $("select");
    for (i = 0, len = ref.length; i < len; i++) {
      select = ref[i];
      new SelectView({
        el: select
      });
    }
    return Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
  };

  ProductView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function(event) {
        _this.delegateEvents();
        return _this._render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function(event) {
        var ref, ref1, ref2;
        _this.undelegateEvents();
        if ((ref = _this.zoomView) != null) {
          ref.prepareRemove();
        }
        if ((ref1 = _this.zoomView) != null) {
          ref1.remove();
        }
        return (ref2 = _this.relatedView) != null ? ref2.remove() : void 0;
      };
    })(this));
  };

  ProductView.prototype.setupVariants = function() {
    var dropdownSettings;
    if (!this.$variantDropdowns.length) {
      return;
    }
    dropdownSettings = {
      $addToCartButton: this.$addToCartButton,
      $priceFields: this.$priceArea,
      $productForm: this.$productForm,
      $productThumbnails: this.$productThumbnails,
      $selector: this.$variantDropdowns,
      formID: this.formID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: "select"
    };
    return this.variantHelpers = new VariantHelper(dropdownSettings);
  };

  ProductView.prototype.switchProductImage = function(e, newImage) {
    var originalImage;
    originalImage = this.$("#product-image-showcase img");
    this.$("#product-image-thumbnails li").removeClass("active");
    if (e) {
      this.$(e.target).parent().addClass("active");
      originalImage.attr("src", this.$(e.target).data("high-res"));
    } else {
      this.$(".product-thumbnail[data-image-position='" + (newImage.position - 1) + "']").addClass("active");
      Shopify.Image.switchImage(newImage, originalImage[0]);
    }
    return originalImage.trigger("prepare-zoom");
  };

  ProductView.prototype.addToCart = function(e) {
    var button;
    e.preventDefault();
    if (this.hasAjax) {
      this.$(".product-message-wrapper").remove();
      if (this.addingToCart === true || this.$(".product-form").serialize() === "") {
        return false;
      }
      button = this.$("#product-add .action-btn");
      if (!button.hasClass("disabled")) {
        this.addingToCart = true;
        return Shopify.addItemFromForm("product-form", (function(_this) {
          return function(item) {
            var message;
            message = Theme.addToCartSuccess.replace("{{ product }}", "" + _this.product.title).replace("{{ cart_link }}", "<a href='/cart'>cart</a>").replace("{{ continue_link }}", "<a href='/collections/all'>Continue Shopping</a>").replace("{{ checkout_link }}", "<a href='/checkout'>check out</a>");
            return setTimeout(function() {
              _this.$("#product-add-to-cart").append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("success-message").removeClass("error-message");
              _this.addingToCart = false;
              return _this.updateCart();
            }, 500);
          };
        })(this));
      }
    } else {
      if (!this.$(e.target).hasClass("disabled")) {
        this.$(e.target).addClass("disabled");
        return this.$(".product-form").submit();
      }
    }
  };

  ProductView.prototype.updateCart = function() {
    return Shopify.getCart((function(_this) {
      return function(cart) {
        var cartCount, cartTotal;
        if (cart.item_count === 1) {
          cartCount = "1 item".replace("1", "" + cart.item_count);
        } else {
          cartCount = "0 items".replace("0", "" + cart.item_count);
        }
        $(".cart-item-count-wrap").text(cartCount);
        cartTotal = Shopify.formatMoney(cart.total_price, Theme.moneyFormat);
        $(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).text(cartTotal);
        return $(".currency-switcher").trigger("reset-currency");
      };
    })(this));
  };

  ProductView.prototype.handleErrors = function(error) {
    var max, message, responseJSON, target, variant, variantID;
    responseJSON = $.parseJSON(error.responseText);
    if (responseJSON.message === "Cart Error") {
      variantID = parseInt(this.$(this.productSelect).val(), 10);
      target = (function() {
        var i, len, ref, results;
        ref = this.product.variants;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          variant = ref[i];
          if (variant.id === variantID) {
            results.push(variant);
          }
        }
        return results;
      }).call(this);
      max = target[0].inventory_quantity;
      message = Theme.productStockErrorMessage.replace("{{ stock }}", max);
    } else {
      message = Theme.productGeneralErrorMessage;
    }
    return setTimeout((function(_this) {
      return function() {
        _this.$("#product-add-to-cart").append("<li class=\"product-message-wrapper\"><p class=\"product-message\">" + message + "</p></li>").addClass("error-message").removeClass("success-message");
        return _this.addingToCart = false;
      };
    })(this), 1000);
  };

  return ProductView;

})(Backbone.View);

window.BlogView = (function(superClass) {
  extend(BlogView, superClass);

  function BlogView() {
    return BlogView.__super__.constructor.apply(this, arguments);
  }

  BlogView.prototype.initialize = function() {
    this.sectionBinding();
    return this.render();
  };

  BlogView.prototype.render = function() {
    this.grid = this.$("[data-blog]");
    if (this.grid.length) {
      return this.initializeMasonryGrid();
    }
  };

  BlogView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        return _this.undelegateEvents();
      };
    })(this));
  };

  BlogView.prototype.initializeMasonryGrid = function() {
    this.grid.masonry({
      itemSelector: "[data-article-item]",
      columnWidth: ".article-grid-sizer",
      gutter: ".article-gutter-sizer",
      percentPosition: true
    });
    return this.grid.imagesLoaded().progress((function(_this) {
      return function(instance, image) {
        return _this.grid.data('masonry').layout();
      };
    })(this));
  };

  return BlogView;

})(Backbone.View);

window.RTEView = (function(superClass) {
  extend(RTEView, superClass);

  function RTEView() {
    return RTEView.__super__.constructor.apply(this, arguments);
  }

  RTEView.prototype.events = {
    "click .tabs li": "switchTabs"
  };

  RTEView.prototype.initialize = function() {
    this.setupTabs();
    return this.$el.fitVids();
  };

  RTEView.prototype.switchTabs = function(e) {
    var content, position, tab, tabContainer, tabContentContainer;
    tab = $(e.currentTarget);
    tabContainer = tab.parent();
    tabContentContainer = tabContainer.next();
    position = tab.index();
    content = tabContentContainer.find("> li").eq(position);
    tabContainer.find("> li").add(tabContentContainer.find("> li")).removeClass("active");
    return tab.add(content).addClass("active");
  };

  RTEView.prototype.setupTabs = function() {
    var tabs;
    tabs = this.$el.find(".tabs");
    return tabs.find("li:first").add(tabs.next().find("li:first")).addClass("active");
  };

  return RTEView;

})(Backbone.View);

window.SelectView = (function(superClass) {
  extend(SelectView, superClass);

  function SelectView() {
    return SelectView.__super__.constructor.apply(this, arguments);
  }

  SelectView.prototype.events = {
    "change": "updateSelectText"
  };

  SelectView.prototype.initialize = function() {
    if (!(this.$el.parent(".select-wrapper").length || this.$el.hasClass("product-variants"))) {
      this.$el.wrap("<div class='select-wrapper' />").parent().prepend('<svg role="img" class="select-dropdown"><use xlink:href="#icon-dropdown"></use></svg>').prepend("<span class='selected-text'></span>");
    }
    this.updateSelectText();
    if (!this.$el.hasClass("product-variants")) {
      this.$el.show();
    }
    return $("#address-country").on("change", (function(_this) {
      return function() {
        return _this.updateSelectText("province");
      };
    })(this));
  };

  SelectView.prototype.updateSelectText = function(select) {
    var newOption, target;
    if (select === "province") {
      target = $("#address-province");
    } else {
      target = this.$el;
    }
    newOption = target.find("option:selected").text() || target.find("option").eq(0).val();
    return target.siblings(".selected-text").text(newOption);
  };

  return SelectView;

})(Backbone.View);

window.ShareView = (function(superClass) {
  extend(ShareView, superClass);

  function ShareView() {
    return ShareView.__super__.constructor.apply(this, arguments);
  }

  ShareView.prototype.events = {
    "click": "closeShare",
    "click .share-widget-toggle": "openShare"
  };

  ShareView.prototype.openShare = function(e) {
    var otherShareWidgets, targetShareWidget;
    targetShareWidget = this.$(e.target).closest(".article-meta-wrap");
    otherShareWidgets = $(".article-meta-wrap").not(targetShareWidget);
    targetShareWidget.addClass("active");
    return otherShareWidgets.removeClass("active");
  };

  ShareView.prototype.closeShare = function(e) {
    if (!(this.$(e.target).closest(".share-widget-toggle").length || this.$(e.target).closest(".share-widget").length)) {
      return $(".article-meta-wrap").removeClass("active");
    }
  };

  return ShareView;

})(Backbone.View);

window.QuickShopView = (function(superClass) {
  extend(QuickShopView, superClass);

  function QuickShopView() {
    return QuickShopView.__super__.constructor.apply(this, arguments);
  }

  QuickShopView.prototype.events = {
    "click .product-item-quick-shop .available": "openQuickShop",
    "click .quick-shop-modal": "closeQuickShop",
    "click .quick-shop-add": "addToCart",
    "click .quick-shop-close": "closeQuickShop",
    "click .quick-shop-close-x": "closeQuickShopWithX"
  };

  QuickShopView.prototype.initialize = function() {
    this.quickShopModal = $(".quick-shop-modal");
    this.quickShopConfirmation = this.$(".quick-shop-confirmation");
    this.minimumPriceArea = this.$(".quick-shop-price-minimum");
    this.addingToCart = false;
    return this.transitionend = (function(transition) {
      var transEndEventNames;
      transEndEventNames = {
        "-webkit-transition": "webkitTransitionEnd",
        "-moz-transition": "transitionend",
        transition: "transitionend"
      };
      return transEndEventNames[transition];
    })(Modernizr.prefixed("transition"));
  };

  QuickShopView.prototype.openQuickShop = function(e) {
    var i, len, ref, select, target;
    e.preventDefault();
    target = $(e.currentTarget);
    this.product = target.data("product-json");
    this.itemId = target.data("quickshop-id");
    this.quickShopContent = $("#quick-shop-" + this.itemId);
    this.setupVariants(this.quickShopContent);
    ref = this.$("select");
    for (i = 0, len = ref.length; i < len; i++) {
      select = ref[i];
      new SelectView({
        el: select
      });
    }
    this.quickShopModal.addClass("visible").append(this.quickShopContent);
    setTimeout((function(_this) {
      return function() {
        _this.quickShopModal.addClass("active");
        _this.quickShopContent.addClass("active");
        return $(document.body).addClass("quick-shop-open");
      };
    })(this), 20);
    this.positionQuickShop(this.quickShopContent);
    return Shopify.onError = (function(_this) {
      return function(XMLHttpRequest) {
        return _this.handleErrors(XMLHttpRequest);
      };
    })(this);
  };

  QuickShopView.prototype.closeQuickShopWithX = function(e, confirm, hasError) {
    var $gridItem;
    $gridItem = $("[data-product-item-id='" + this.itemId + "']");
    if (e.currentTarget) {
      this.quickShopModal.removeClass("visible");
      this.quickShopModal.removeClass("active");
      $gridItem.append(this.quickShopContent);
      this.quickShopConfirmation.removeClass("active");
      this.quickShopContent.removeClass("active");
      $(document.body).removeClass("quick-shop-open");
      return this.addingToCart = false;
    }
  };

  QuickShopView.prototype.closeQuickShop = function(e, confirm, hasError) {
    var $gridItem;
    $gridItem = $("[data-product-item-id='" + this.itemId + "']");
    if (e) {
      if (!(this.$(e.target).closest(".quick-shop-container").length || this.$(e.target).closest(".product-item-quick-shop").length)) {
        this.quickShopModal.removeClass("active").one(this.transitionend, (function(_this) {
          return function() {
            _this.quickShopModal.removeClass("visible");
            $gridItem.append(_this.quickShopContent);
            _this.quickShopConfirmation.removeClass("active");
            _this.quickShopContent.removeClass("active");
            $(document.body).removeClass("quick-shop-open");
            _this.addingToCart = false;
            if (hasError === "remove error") {
              return _this.$(".quick-shop-message").remove();
            }
          };
        })(this));
      }
    }
    if (confirm) {
      return this.quickShopContent.removeClass("active").one(this.transitionend, (function(_this) {
        return function() {
          _this.quickShopContent.off(_this.transitionend);
          return _this.quickShopConfirmation.addClass("active");
        };
      })(this));
    }
  };

  QuickShopView.prototype.setupVariants = function(quickShopContent) {
    var $addToCartButton, $priceArea, $productJSON, $productSettings, $quickShopForm, $variantDropdowns, dropdownSettings;
    this.quickShopContent = quickShopContent;
    $quickShopForm = $(".quickshop-form", this.quickShopContent);
    this.quickshopformID = parseInt($quickShopForm.attr('data-quickshop-form'), 10);
    this.productSelect = "#product-select-" + this.quickshopformID;
    $priceArea = $('.quick-shop-price-container', this.quickShopContent);
    $addToCartButton = $(".quick-shop-add", this.quickShopContent);
    $productJSON = $("[data-quickshop-json-" + this.quickshopformID + "]", this.quickShopContent);
    $productSettings = $("[data-quickshop-settings-" + this.quickshopformID + "]", this.quickShopContent);
    this.productJSON = JSON.parse($productJSON.text());
    this.productSettings = JSON.parse($productSettings.text());
    $variantDropdowns = $("[data-option-select=" + this.quickshopformID + "]", this.quickShopContent);
    this.options = this.productJSON.options;
    this.variants = this.productJSON.variants;
    if (!$variantDropdowns.length) {
      return;
    }
    dropdownSettings = {
      $addToCartButton: $addToCartButton,
      $priceFields: $priceArea,
      $productForm: $quickShopForm,
      $selector: $variantDropdowns,
      formID: this.quickshopformID,
      productSettings: this.productSettings,
      productJSON: this.productJSON,
      type: 'select'
    };
    return this.variantHelpers = new VariantHelper(dropdownSettings);
  };

  QuickShopView.prototype.switchCurrency = function(minimum, compare) {
    var attribute, i, len, minimumPriceArea, ref;
    minimumPriceArea = this.$(".quick-shop-price-minimum");
    ref = minimumPriceArea[0].attributes;
    for (i = 0, len = ref.length; i < len; i++) {
      attribute = ref[i];
      if (attribute.name.indexOf("data-") > -1) {
        minimumPriceArea.attr(attribute.name, "");
      }
    }
    minimumPriceArea.attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, Shopify.formatMoney(minimum, Theme.moneyFormat)).attr("data-currency", Theme.currency);
    this.$(".quick-shop-price-compare").attr("data-currency-" + Theme.currency, Shopify.formatMoney(compare, Theme.moneyFormat)).attr("data-currency", Theme.currency);
    return $(".currency-switcher").trigger("reset-currency");
  };

  QuickShopView.prototype.addToCart = function(e) {
    var $form, button, formData;
    if (this.addingToCart === true) {
      return false;
    }
    $form = $("#product-form-" + this.quickshopformID);
    formData = $form.serialize();
    if (formData === "") {
      return false;
    }
    e.preventDefault();
    button = $form.find(".quick-shop-add");
    if (!button.children().hasClass("disabled")) {
      this.addingToCart = true;
      return Shopify.addItemFromForm("product-form-" + this.quickshopformID, (function(_this) {
        return function(item) {
          _this.updateCart(item);
          return _this.closeQuickShop(null, true);
        };
      })(this));
    }
  };

  QuickShopView.prototype.updateCart = function(item) {
    return Shopify.getCart((function(_this) {
      return function(cart) {
        var cartCount, newFormattedAmount;
        if (cart.item_count === 1) {
          cartCount = "1 item".replace("1", "" + cart.item_count);
        } else {
          cartCount = "0 items".replace("0", "" + cart.item_count);
        }
        newFormattedAmount = Shopify.formatMoney(cart.total_price, "");
        _this.$(".cart-item-count-wrap").text(cartCount);
        _this.$(".cart-amount-wrap").attr("data-currency-" + Currency.currentCurrency, "").attr("data-currency-" + Theme.currency, cart.total_price).attr("data-currency", Theme.currency).html(newFormattedAmount);
        if (Theme.currencySwitcher) {
          return $(".currency-switcher").trigger("reset-currency");
        }
      };
    })(this));
  };

  QuickShopView.prototype.positionQuickShop = function(quickShop) {
    var quickShopConfirmationHeight, quickShopHeight;
    quickShopHeight = quickShop.outerHeight();
    quickShop.css({
      marginTop: quickShopHeight / -2
    });
    quickShopConfirmationHeight = this.quickShopConfirmation.outerHeight();
    return this.quickShopConfirmation.css({
      marginTop: quickShopConfirmationHeight / -2
    });
  };

  QuickShopView.prototype.handleErrors = function(error) {
    var max, message, target, variant, variantID;
    error = $.parseJSON(error.responseText);
    console.log("error", error);
    if (error.message === "Cart Error") {
      variantID = parseInt(this.$("#product-select-" + this.quickshopformID).val(), 10);
      target = (function() {
        var i, len, ref, results;
        ref = this.product.variants;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          variant = ref[i];
          if (variant.id === variantID) {
            results.push(variant);
          }
        }
        return results;
      }).call(this);
      max = target[0].inventory_quantity;
      message = "Unfortunately, we only have {{ stock }} in stock.".replace("{{ stock }}", max);
    } else {
      message = "We were unable to add this product to your cart. Please try again later. Contact us if you continue to have issues.";
    }
    this.quickShopContent.append("<div class='quick-shop-message'>" + message + "</div>");
    return setTimeout((function(_this) {
      return function() {
        _this.closeQuickShop(null, null, "remove error");
        return _this.addingToCart = false;
      };
    })(this), 1000);
  };

  return QuickShopView;

})(Backbone.View);

window.CurrencyView = (function(superClass) {
  extend(CurrencyView, superClass);

  function CurrencyView() {
    return CurrencyView.__super__.constructor.apply(this, arguments);
  }

  CurrencyView.prototype.events = {
    "change [name=currencies]": "convertAll",
    "switch-currency": "switchCurrency",
    "reset-currency": "resetCurrency"
  };

  CurrencyView.prototype.initialize = function() {
    this.sectionBinding();
    return this.render();
  };

  CurrencyView.prototype.sectionBinding = function() {
    this.$el.on('shopify:section:load', (function(_this) {
      return function() {
        _this.delegateEvents();
        return _this.render();
      };
    })(this));
    return this.$el.on('shopify:section:unload', (function(_this) {
      return function() {
        return _this.undelegateEvents();
      };
    })(this));
  };

  CurrencyView.prototype.render = function() {
    var cents, doubleMoney, i, j, len, len1, money, ref, ref1;
    Currency.format = Theme.currencySwitcherFormat;
    Currency.money_with_currency_format = {};
    Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
    Currency.money_format = {};
    Currency.money_format[Theme.currency] = Theme.moneyFormat;
    this.defaultCurrency = "CAD";
    this.cookieCurrency = Currency.cookie.read();
    if (this.cookieCurrency) {
      this.$("[name=currencies]").val(this.cookieCurrency);
    }
    ref = this.$("span.money span.money");
    for (i = 0, len = ref.length; i < len; i++) {
      doubleMoney = ref[i];
      $(doubleMoney).parents("span.money").removeClass("money");
    }
    ref1 = this.$("span.money");
    for (j = 0, len1 = ref1.length; j < len1; j++) {
      money = ref1[j];
      $(money).data("currency-" + Theme.currency, $(money).html());
      if (Currency.format === "money_with_currency_format") {
        cents = parseInt($(money).html().replace(/[^0-9]/g, ''), 10);
        $(money).html(Shopify.formatMoney(cents, Theme.moneyFormat));
      }
    }
    this.switchCurrency();
    return this.$(".selected-currency").text(Currency.currentCurrency);
  };

  CurrencyView.prototype.resetCurrency = function() {
    return Currency.convertAll(Theme.currency, this.$("[name=currencies]").val());
  };

  CurrencyView.prototype.switchCurrency = function() {
    if (this.cookieCurrency === null) {
      if (Theme.currency === !this.defaultCurrency) {
        return Currency.convertAll(Theme.currency, this.defaultCurrency);
      } else {
        return Currency.currentCurrency = this.defaultCurrency;
      }
    } else if (this.$("[name=currencies]").size() && this.$("[name=currencies] option[value=" + this.cookieCurrency + "]").size() === 0) {
      Currency.currentCurrency = Theme.currency;
      return Currency.cookie.write(Theme.currency);
    } else if (this.cookieCurrency === Theme.currency) {
      return Currency.currentCurrency = Theme.currency;
    } else {
      return Currency.convertAll(Theme.currency, this.cookieCurrency);
    }
  };

  CurrencyView.prototype.convertAll = function(e, variant, selector) {
    var newCurrency;
    newCurrency = $(e.target).val();
    Currency.convertAll(Currency.currentCurrency, newCurrency);
    this.$(".selected-currency").text(Currency.currentCurrency);
    return this.cookieCurrency = newCurrency;
  };

  return CurrencyView;

})(Backbone.View);

window.PasswordView = (function(superClass) {
  extend(PasswordView, superClass);

  function PasswordView() {
    return PasswordView.__super__.constructor.apply(this, arguments);
  }

  PasswordView.prototype.events = {
    'click [data-close-modal]': 'closeModal',
    'click .admin-login-modal': 'openModal'
  };

  PasswordView.prototype.initialize = function() {
    this.modalWrapper = $('.password-page-modal-wrapper');
    this.modalContent = this.modalWrapper.find('.password-page-modal');
    this.openByDefault = this.modalWrapper.find('[data-open-modal]').length;
    if (this.openByDefault) {
      this.openModal();
    }
    return $(window).resize((function(_this) {
      return function() {
        return _this.positionModal();
      };
    })(this));
  };

  PasswordView.prototype.closeModal = function() {
    if (this.modalWrapper.hasClass('visible')) {
      this.modalWrapper.removeClass("visible");
      return this.$el.removeClass("scroll-locked");
    }
  };

  PasswordView.prototype.openModal = function() {
    this.$el.addClass("scroll-locked");
    this.positionModal();
    return this.modalWrapper.addClass("visible");
  };

  PasswordView.prototype.positionModal = function() {
    return this.modalContent.css({
      marginTop: -(this.modalContent.outerHeight() / 2),
      marginLeft: -(this.modalContent.outerWidth() / 2)
    });
  };

  return PasswordView;

})(Backbone.View);

window.GiftCardView = (function(superClass) {
  extend(GiftCardView, superClass);

  function GiftCardView() {
    return GiftCardView.__super__.constructor.apply(this, arguments);
  }

  GiftCardView.prototype.initialize = function() {
    return this.addQrCode();
  };

  GiftCardView.prototype.addQrCode = function() {
    var qrWrapper;
    qrWrapper = $('[data-qr-code]');
    return new QRCode(qrWrapper[0], {
      text: qrWrapper.data('qr-code'),
      width: 120,
      height: 120
    });
  };

  return GiftCardView;

})(Backbone.View);

window.ThemeEditor = (function(superClass) {
  extend(ThemeEditor, superClass);

  function ThemeEditor() {
    return ThemeEditor.__super__.constructor.apply(this, arguments);
  }

  ThemeEditor.prototype.initialize = function() {
    this.instanceHandlers = {};
    this.instances = {};
    return $(document).on('shopify:section:load', (function(_this) {
      return function(event) {
        return _this._onSectionLoad(event);
      };
    })(this)).on('shopify:section:unload', (function(_this) {
      return function(event) {
        return _this._onSectionUnload(event);
      };
    })(this)).on('shopify:section:select', (function(_this) {
      return function(event) {
        return _this._onSectionSelect(event);
      };
    })(this)).on('shopify:section:deselect', (function(_this) {
      return function(event) {
        return _this._onSectionDeselect(event);
      };
    })(this)).on('shopify:block:select', (function(_this) {
      return function(event) {
        return _this._onBlockSelect(event);
      };
    })(this)).on('shopify:block:deselect', (function(_this) {
      return function(event) {
        return _this._onBlockDeselect(event);
      };
    })(this));
  };

  ThemeEditor.prototype._findInstance = function(event) {
    var $container, instance;
    instance = this.instances[event.originalEvent.detail.sectionId];
    if (instance != null) {
      return instance;
    } else {
      $container = $('[data-section-id]', event.target);
      return this._createInstance($container);
    }
  };

  ThemeEditor.prototype._createInstance = function($container, instanceHandler) {
    var instance, sectionId, sectionType;
    sectionType = $container.attr('data-section-type');
    sectionId = $container.attr('data-section-id');
    if (sectionType == null) {
      return;
    }
    instanceHandler = instanceHandler || this.instanceHandlers[sectionType];
    instance = {
      instanceHandler: instanceHandler,
      $container: $container,
      sectionId: sectionId
    };
    this.instances[sectionId] = instance;
    return instance;
  };


  /*
      Action: A section has been added or re-rendered.
      Expected: Re-execute any JavaScript needed for the section to work and
          display properly (as if the page had just been loaded).
   */

  ThemeEditor.prototype._onSectionLoad = function(event) {
    var $container, ref, ref1;
    $container = $('[data-section-id]', event.target);
    if (!$container.length) {
      return;
    }
    return (ref = this._createInstance($container)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionLoad === "function" ? ref1.onSectionLoad(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: A section has been deleted or is being re-rendered.
      Expected: Clean up any event listeners, variables, etc., so that
          nothing breaks when the page is interacted with and no memory leaks occur.
   */

  ThemeEditor.prototype._onSectionUnload = function(event) {
    var instance, ref;
    instance = this._findInstance(event);
    if (instance != null) {
      if ((ref = instance.instanceHandler) != null) {
        if (typeof ref.onSectionUnload === "function") {
          ref.onSectionUnload(event);
        }
      }
    }
    if (instance) {
      return delete this.instances[instance.sectionId];
    }
  };


  /*
      Action: User has selected the section in the sidebar.
      Expected: Make sure the section is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Could be used to pause a slideshow
   */

  ThemeEditor.prototype._onSectionSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionSelect === "function" ? ref1.onSectionSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the section in the sidebar.
      Expected: (None)
      Example: Could be used to restart slideshows that are no longer being interacted with.
   */

  ThemeEditor.prototype._onSectionDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onSectionDeselect === "function" ? ref1.onSectionDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has selected the block in the sidebar.
      Expected: Make sure the block is in view and stays
          in view while selected (scrolling happens automatically).
      Example: Can be used to to trigger a slideshow to bring a slide/block into view
   */

  ThemeEditor.prototype._onBlockSelect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockSelect === "function" ? ref1.onBlockSelect(event) : void 0 : void 0 : void 0;
  };


  /*
      Action: User has deselected the block in the sidebar.
      Expected: (None)
      Example: Resume a slideshow
   */

  ThemeEditor.prototype._onBlockDeselect = function(event) {
    var ref, ref1;
    return (ref = this._findInstance(event)) != null ? (ref1 = ref.instanceHandler) != null ? typeof ref1.onBlockDeselect === "function" ? ref1.onBlockDeselect(event) : void 0 : void 0 : void 0;
  };


  /*
      Auto initialisation of a section for the store front
   */

  ThemeEditor.prototype._sectionInit = function(instance) {
    var ref;
    return instance != null ? (ref = instance.instanceHandler) != null ? typeof ref.init === "function" ? ref.init(instance) : void 0 : void 0 : void 0;
  };


  /*
      Registration of a section
          - Takes a string parameter as the first argument which
            matches to `[data-section-type]`
  
       * Example
          @sections = new Sections()
          @sections.register('some-section-type', @someSectionClass)
   */

  ThemeEditor.prototype.register = function(type, instanceHandler) {

    /*
        Storage of a instanceHandler based on the sectionType allows _onSectionLoad
           to connect a new section to it's registered instanceHandler
     */
    this.instanceHandlers[type] = instanceHandler;
    return $("[data-section-type=" + type + "]").each((function(_this) {
      return function(index, container) {
        var $container;
        $container = $(container);
        return _this._sectionInit(_this._createInstance($container, instanceHandler));
      };
    })(this));
  };


  /*
      Public method to retrieve information on an instance based on the
      bubbled `event`
   */

  ThemeEditor.prototype.getInstance = function(event) {
    return this._findInstance(event);
  };

  return ThemeEditor;

})(Backbone.View);

window.ThemeUtils = {
  extend: function() {
    var dest, i, k, len, obj, objs, v;
    dest = arguments[0], objs = 2 <= arguments.length ? slice.call(arguments, 1) : [];
    for (i = 0, len = objs.length; i < len; i++) {
      obj = objs[i];
      for (k in obj) {
        v = obj[k];
        dest[k] = v;
      }
    }
    return dest;
  },
  windowWidth: function() {
    return window.innerWidth || this.window.width();
  },
  debounce: function(func, wait, immediate) {
    var timeout;
    timeout = null;
    return function() {
      var args, callNow, context, later;
      context = this;
      args = arguments;
      later = function() {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  },
  inViewport: function(el) {
    var bounds, rect;
    if (typeof jQuery === "function" && el instanceof jQuery) {
      el = el[0];
    }
    rect = el.getBoundingClientRect();
    bounds = {
      top: rect.top >= 0,
      bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    };
    return bounds.top && bounds.bottom;
  },
  unique: function(array) {
    var i, key, output, ref, results, value;
    output = {};
    for (key = i = 0, ref = array.length; 0 <= ref ? i < ref : i > ref; key = 0 <= ref ? ++i : --i) {
      output[array[key]] = array[key];
    }
    results = [];
    for (key in output) {
      value = output[key];
      results.push(value);
    }
    return results;
  }
};

window.LinkedOptions = (function() {
  function LinkedOptions(options) {
    this.options = options;
    this._init();
  }

  LinkedOptions.prototype._init = function() {
    return this._mapVariants(this.options.productJSON);
  };

  LinkedOptions.prototype._getCurrent = function(optionIndex) {
    var key, option1, option2, selector;
    if (this.options.type === 'select') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.eq(0);
          break;
        case 1:
          key = this.options.$selector.eq(0).val();
          selector = this.options.$selector.eq(1);
          break;
        case 2:
          key = (this.options.$selector.eq(0).val()) + " / " + (this.options.$selector.eq(1).val());
          selector = this.options.$selector.eq(2);
      }
    }
    if (this.options.type === 'radio') {
      switch (optionIndex) {
        case 0:
          key = 'root';
          selector = this.options.$selector.filter('[data-option-index=0]').filter(':checked');
          break;
        case 1:
          key = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          selector = this.options.$selector.filter('[data-option-index=1]').filter(':checked');
          break;
        case 2:
          option1 = this.options.$selector.filter('[data-option-index=0]').filter(':checked').val();
          option2 = this.options.$selector.filter('[data-option-index=1]').filter(':checked').val();
          key = option1 + " / " + option2;
          selector = this.options.$selector.filter('[data-option-index=2]').filter(':checked');
      }
    }
    return {
      key: key,
      selector: selector
    };
  };

  LinkedOptions.prototype._updateOptions = function(optionIndex, optionsMap) {
    var $nextOption, $option, $selector, $selectorOptions, availableOptions, i, initialValue, j, key, len, len1, nextSelector, option, ref, selector, updateSelected;
    nextSelector = optionIndex + 1;
    updateSelected = false;
    ref = this._getCurrent(optionIndex), key = ref.key, selector = ref.selector;
    availableOptions = optionsMap[key] || [];
    if (this.options.type === 'select') {
      $selector = this.options.$productForm.find(selector);
      initialValue = $selector.val();
      $selectorOptions = $selector.find('option');
      for (i = 0, len = $selectorOptions.length; i < len; i++) {
        option = $selectorOptions[i];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.selected) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('selected', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (availableOptions.indexOf(initialValue) !== -1) {
        $selector.val(initialValue);
      }
      if (updateSelected) {
        $selectorOptions.filter(':not(:disabled)').eq(0).prop('selected', true);
      }
    }
    if (this.options.type === 'radio') {
      $selector = this.options.$selector.filter("[data-option-index=" + optionIndex + "]");
      for (j = 0, len1 = $selector.length; j < len1; j++) {
        option = $selector[j];
        $option = $(option);
        if (availableOptions.indexOf(option.value) === -1) {
          if (option.checked) {
            updateSelected = true;
          }
          $option.prop('disabled', true).prop('checked', false);
        } else {
          $option.prop('disabled', false);
        }
      }
      if (updateSelected) {
        $selector.filter(':not(:disabled)').eq(0).attr('checked', true).trigger('click');
      }
    }
    $selector.trigger('change');
    $nextOption = this.options.$selector.filter("[data-option-index=" + nextSelector + "]");
    if ($nextOption.length !== 0) {
      return this._updateOptions(nextSelector, optionsMap);
    }
  };

  LinkedOptions.prototype._mapVariants = function(product) {
    var i, key, len, optionsMap, ref, variant;
    optionsMap = [];
    optionsMap['root'] = [];
    ref = product.variants;
    for (i = 0, len = ref.length; i < len; i++) {
      variant = ref[i];
      if (variant.available) {
        optionsMap['root'].push(variant.option1);
        optionsMap['root'] = window.ThemeUtils.unique(optionsMap['root']);
        if (product.options.length > 1) {
          key = variant.option1;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option2);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
        if (product.options.length > 2) {
          key = variant.option1 + " / " + variant.option2;
          optionsMap[key] = optionsMap[key] || [];
          optionsMap[key].push(variant.option3);
          optionsMap[key] = window.ThemeUtils.unique(optionsMap[key]);
        }
      }
    }
    this._updateOptions(0, optionsMap);
    return this.options.$selector.on('change', (function(_this) {
      return function(event) {
        var index, nextSelector;
        index = parseInt($(event.currentTarget).attr('data-option-index'), 10);
        nextSelector = index + 1;
        return _this._updateOptions(nextSelector, optionsMap);
      };
    })(this));
  };

  return LinkedOptions;

})();

window.VariantHelper = (function() {
  function VariantHelper(options) {
    var defaultOptions, isShopify;
    defaultOptions = {
      $addToCartButton: null,
      $priceFields: null,
      $productForm: null,
      $productThumbnails: null,
      $selector: null,
      type: 'select',
      productJSON: null,
      productSettings: null
    };
    this.options = window.ThemeUtils.extend(defaultOptions, options);
    this.$body = $(document.body);
    this.linkedOptions = null;
    this.enableHistory = false;
    this.$masterSelect = this.options.$productForm.find("#product-select-" + this.options.formID);
    isShopify = window.Shopify && window.Shopify.preview_host;
    if (window.history && window.history.replaceState && this.options.productSettings.enableHistory && !isShopify) {
      this.enableHistory = true;
    }
    this._init();
    this._bindEvents();
  }

  VariantHelper.prototype._init = function() {
    var i, len, ref, select;
    if (this.options.type === 'select') {
      ref = this.options.$selector;
      for (i = 0, len = ref.length; i < len; i++) {
        select = ref[i];
        this._setSelectLabel(null, $(select));
      }
    }
    if (this.options.productSettings.linkedOptions) {
      this.linkedOptions = new LinkedOptions(this.options);
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._bindEvents = function() {
    return this.options.$selector.on('change', (function(_this) {
      return function(event) {
        return _this._variantChange(event);
      };
    })(this));
  };

  VariantHelper.prototype._setSelectLabel = function(event, $target) {
    var selectedOption;
    if (event == null) {
      event = null;
    }
    if ($target == null) {
      $target = false;
    }
    if (!$target) {
      $target = $(event.currentTarget);
    }
    selectedOption = $target.find('option:selected').val();
    return $target.prev('[data-select-text]').find('[data-selected-option]').text(selectedOption);
  };

  VariantHelper.prototype._getCurrentOptions = function() {
    var $inputs, productOptions;
    productOptions = [];
    $inputs = this.options.$selector;
    if (this.options.type === 'radio') {
      $inputs = $inputs.filter(':checked');
    }
    $inputs.each(function(index, element) {
      return productOptions.push($(element).val());
    });
    return productOptions;
  };

  VariantHelper.prototype._getVariantFromOptions = function(productOptions) {
    var foundVariant, i, isMatch, len, ref, variant;
    if (this.options.productJSON.variants == null) {
      return;
    }
    foundVariant = null;
    ref = this.options.productJSON.variants;
    for (i = 0, len = ref.length; i < len; i++) {
      variant = ref[i];
      isMatch = productOptions.every(function(value) {
        return variant.options.indexOf(value) !== -1;
      });
      if (isMatch) {
        foundVariant = variant;
      }
    }
    return foundVariant;
  };

  VariantHelper.prototype._updateMasterSelect = function(variant) {
    var ref;
    if (variant == null) {
      return;
    }
    if ((ref = this.$masterSelect.find("[data-variant-id=" + variant.id + "]")) != null) {
      ref.prop('selected', true);
    }
    return this.$masterSelect.trigger('change');
  };

  VariantHelper.prototype._updatePrice = function(variant) {
    var $addToCartButton, $priceFields, productSettings;
    $addToCartButton = this.options.$addToCartButton;
    $priceFields = this.options.$priceFields;
    productSettings = this.options.productSettings;
    if (variant != null) {
      if (variant.available) {
        $addToCartButton.val(productSettings.addToCartText).removeClass('disabled').removeAttr('disabled');
      } else {
        $addToCartButton.val(productSettings.soldOutText).addClass('disabled').attr('disabled', 'disabled');
      }
      if (variant.compare_at_price > variant.price) {
        $priceFields.find('.money:first-child').html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $priceFields.find('.product-price-compare').html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat)).removeClass('hidden');
      } else {
        $priceFields.find('.money').html(Shopify.formatMoney(variant.price, Theme.moneyFormat));
        $priceFields.find('.product-price-compare').addClass('hidden');
      }
    } else {
      $addToCartButton.val(productSettings.unavailableText).addClass('disabled').attr('disabled', 'disabled');
    }
    return this._updateCurrency();
  };

  VariantHelper.prototype._updateImages = function(variant) {
    var index, ref;
    index = variant != null ? (ref = variant.featured_image) != null ? ref.position : void 0 : void 0;
    if (!((index != null) && (this.options.$productThumbnails != null))) {
      return;
    }
    return this.options.$productThumbnails.eq(index - 1).trigger('click');
  };

  VariantHelper.prototype._updateHistory = function(variant) {
    var newUrl, variantUrl;
    if (!(this.enableHistory && (variant != null))) {
      return;
    }
    newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
    variantUrl = newUrl.join('');
    return window.history.replaceState({
      path: variantUrl
    }, '', variantUrl);
  };

  VariantHelper.prototype._variantChange = function(event) {
    var productOptions, variant;
    if (this.options.type === 'select') {
      this._setSelectLabel(event);
    }
    productOptions = this._getCurrentOptions();
    variant = this._getVariantFromOptions(productOptions);
    this._updateMasterSelect(variant);
    this._updatePrice(variant);
    this._updateImages(variant);
    return this._updateHistory(variant);
  };

  VariantHelper.prototype._updateCurrency = function() {
    if (Theme.currencySwitcher) {
      return this.$body.trigger('reset-currency');
    }
  };

  return VariantHelper;

})();

window.ThemeView = (function(superClass) {
  extend(ThemeView, superClass);

  function ThemeView() {
    return ThemeView.__super__.constructor.apply(this, arguments);
  }

  ThemeView.prototype.el = document.body;

  ThemeView.prototype.initialize = function() {
    var body;
    body = $(document.body);
    this.isHome = body.hasClass("template-index");
    this.isProduct = body.hasClass("template-product");
    this.isCollection = body.hasClass("template-collection");
    this.isBlog = body.hasClass("template-blog");
    this.isSearch = body.hasClass("template-search");
    this.isPasswordPage = body.hasClass("template-password");
    this.isGiftCardPage = body.hasClass("gift-card-template");
    this.hasArticle = body.find(".article-meta-wrap");
    return this.isltIE10 = $("html").hasClass("lt-ie10");
  };

  ThemeView.prototype.render = function() {
    var i, j, len, len1, ref, ref1, rte, select;
    this.sections = new ThemeEditor();
    this.sections.register('header', this.headerSetup(this.sections));
    ref = $(".rte");
    for (i = 0, len = ref.length; i < len; i++) {
      rte = ref[i];
      new RTEView({
        el: rte
      });
    }
    if (Theme.currencySwitcher) {
      new CurrencyView({
        el: this.$(".currency-switcher")
      });
    }
    if (this.isHome) {
      new HomeView({
        el: this.$el
      });
    }
    if (this.isProduct) {
      new ProductView({
        el: this.$el
      });
    }
    if (this.isCollection) {
      new CollectionView({
        el: this.$el
      });
    }
    if (this.isBlog) {
      new BlogView({
        el: this.$el
      });
    }
    if (this.isSearch) {
      new ProductListView({
        el: $("#search-results")
      });
    }
    if (this.hasArticle) {
      new ShareView({
        el: this.$el
      });
    }
    if (this.isPasswordPage) {
      new PasswordView({
        el: this.$el
      });
    }
    if (this.isGiftCardPage) {
      new GiftCardView();
    }
    new QuickShopView({
      el: this.$el
    });
    ref1 = $("select");
    for (j = 0, len1 = ref1.length; j < len1; j++) {
      select = ref1[j];
      new SelectView({
        el: select
      });
    }
    if (this.isltIE10) {
      return this.inputPlaceholderFix();
    }
  };

  ThemeView.prototype.headerSetup = function(sections) {
    return {
      instances: {},
      init: function(instance) {
        return this.instances[instance.sectionId] = new HeaderView({
          el: $(".main-header")
        });
      },
      onSectionLoad: function(event) {
        var instance;
        instance = sections.getInstance(event);
        if (!this.instances[instance.sectionId]) {
          return this.init(instance);
        }
      },
      onSectionUnload: function(event) {
        var instance;
        instance = sections.getInstance(event);
        this.instances[instance.sectionId].prepareRemove();
        this.instances[instance.sectionId].remove();
        return delete this.instances[instance.sectionId];
      }
    };
  };

  ThemeView.prototype.inputPlaceholderFix = function() {
    var i, input, len, placeholders, text;
    placeholders = $("[placeholder]");
    for (i = 0, len = placeholders.length; i < len; i++) {
      input = placeholders[i];
      input = $(input);
      if (!(input.val().length > 0)) {
        text = input.attr("placeholder");
        input.attr("value", text);
        input.data("original-text", text);
      }
    }
    placeholders.focus(function() {
      input = $(this);
      if (input.val() === input.data("original-text")) {
        return input.val('');
      }
    });
    return placeholders.blur(function() {
      input = $(this);
      if (input.val().length === 0) {
        return input.val(input.data("original-text"));
      }
    });
  };

  return ThemeView;

})(Backbone.View);

$(function() {
  window.theme = new ThemeView();
  return theme.render();
});
